import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    site: {
      title: 'Diário Oficial Eletrônico'
    },
    entidade: {
      ent_nome: 'Prefeitura Teste',
      ent_capa_diario: 'loander',
      ent_diario_inicial: 0,
      total_diario: 0
    }
  },
  mutations: {
    SET_ENTIDADE: (state, dados) => {
      state.entidade = dados
    }
  },
  actions: {
    entidade({commit}, entidade) {
      commit('SET_ENTIDADE', entidade);
    }
  },
  getters: {
    site(state, getters) {
      return state.site
    },
    entidade(state, getters) {
      return state.entidade
    }
  },
  strict: debug
})
